// Telefonda pwa.css yüzünden sayfayı window değil body kaydırıyor (window.scrollY hep 0).
// Bu yardımcılar iki durumda da çalışır.

export const sayfaKaydirmaY = () =>
  Math.max(window.scrollY, document.documentElement.scrollTop, document.body.scrollTop);

// Kaydırma olayını hem window hem body için dinler; temizleme fonksiyonu döner
export const kaydirmayiDinle = (fn: () => void) => {
  const opts = { passive: true, capture: true } as const;
  document.addEventListener('scroll', fn, opts);
  return () => document.removeEventListener('scroll', fn, opts);
};

export const enUsteKaydir = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  document.body.scrollTo({ top: 0, behavior: 'smooth' });
};

// Üstteki sabit menü payı CSS'te scroll-margin-top ile verilir
export const bolumeKaydir = (id: string) => {
  const el = document.getElementById(id);
  if (!el) return false;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return true;
};
